import { Pipe, PipeTransform } from '@angular/core';
import { readStory } from '../interfaces/story';

@Pipe({ name: 'filterStoriesByStatus' })
export class FilterStoriesByStatusPipe implements PipeTransform {

  transform(stories: readStory[], status: string): readStory[] {
    if (!status || status === 'all') return stories;
    return stories.filter(story => story.status === status);
  }

}
